(() => {
  const storagePrefix = 'theme:product-collection:';
  const maxStoredContextAge = 5 * 60 * 1000;

  const getProductHandle = (pathname) => {
    const match = pathname.match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const getCollectionHandle = (pathname) => {
    const match = pathname.match(/\/collections\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const normalizeText = (value) => value?.trim().toLocaleLowerCase() || '';

  const getVendorContext = (url, productVendor) => {
    if (getCollectionHandle(url.pathname) !== 'vendors') return null;

    const vendor = url.searchParams.get('q');
    if (!vendor || normalizeText(vendor) !== normalizeText(productVendor)) return null;

    return {
      type: 'vendor',
      handle: 'vendors',
      title: productVendor,
      url: `${url.pathname}${url.search}`
    };
  };

  const readStoredContext = (productHandle) => {
    try {
      const value = sessionStorage.getItem(`${storagePrefix}${productHandle}`);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  };

  const saveCollectionOnProductClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const productLink = event.target.closest('a[data-product-link]');
    const collectionSource = productLink?.closest('[data-product-collection-source]');

    if (!productLink || !collectionSource) return;

    const productHandle = getProductHandle(new URL(productLink.href, window.location.origin).pathname);
    if (!productHandle) return;

    const context = {
      productHandle,
      type: collectionSource.dataset.collectionType || 'collection',
      handle: collectionSource.dataset.collectionHandle,
      title: collectionSource.dataset.collectionTitle,
      url: `${window.location.pathname}${window.location.search}`,
      sourceUrl: `${window.location.pathname}${window.location.search}`,
      savedAt: Date.now()
    };

    try {
      sessionStorage.setItem(`${storagePrefix}${productHandle}`, JSON.stringify(context));
    } catch (error) {
      // The referrer fallback below still works when storage is unavailable.
    }
  };

  const updateProductBreadcrumb = () => {
    const product = document.querySelector('[data-main-product]');
    const collectionsData = document.querySelector('[data-product-breadcrumb-collections]');

    if (!product || !collectionsData) return;

    let collections;
    try {
      collections = JSON.parse(collectionsData.textContent);
    } catch (error) {
      return;
    }

    const productHandle = product.dataset.productHandle;
    const productVendor = product.dataset.productVendor;
    let selectedContext = null;
    let selectedHandle = '';
    let referrerUrl = '';

    if (document.referrer) {
      try {
        const referrer = new URL(document.referrer);
        if (referrer.origin === window.location.origin) {
          referrerUrl = `${referrer.pathname}${referrer.search}`;
          selectedContext = getVendorContext(referrer, productVendor);
          if (!selectedContext) selectedHandle = getCollectionHandle(referrer.pathname);
        }
      } catch (error) {
        referrerUrl = '';
      }
    }

    const storedContext = readStoredContext(productHandle);
    const storedContextIsRecent = storedContext
      && storedContext.productHandle === productHandle
      && Date.now() - storedContext.savedAt < maxStoredContextAge;
    const storedContextMatchesReferrer = !referrerUrl
      || referrerUrl === storedContext?.sourceUrl
      || referrerUrl === storedContext?.sourcePath;

    if (!selectedContext && !selectedHandle && storedContextIsRecent && storedContextMatchesReferrer) {
      if (storedContext.type === 'vendor') {
        if (normalizeText(storedContext.title) === normalizeText(productVendor)) {
          selectedContext = storedContext;
        }
      } else {
        selectedHandle = storedContext.handle;
      }
    }

    const historyContext = history.state?.productBreadcrumbCollection;
    if (!selectedContext && !selectedHandle && historyContext?.productHandle === productHandle) {
      if (historyContext.type === 'vendor') {
        if (normalizeText(historyContext.title) === normalizeText(productVendor)) {
          selectedContext = historyContext;
        }
      } else {
        selectedHandle = historyContext.handle;
      }
    }

    if (!selectedContext) {
      const selectedCollection = collections.find((collection) => collection.handle === selectedHandle);
      if (selectedCollection) {
        selectedContext = { ...selectedCollection, type: 'collection' };
      }
    }

    if (!selectedContext) return;

    document.querySelectorAll('[data-product-collection-breadcrumb]').forEach((breadcrumbItem) => {
      const link = breadcrumbItem.querySelector('[data-product-collection-link]');
      const title = breadcrumbItem.querySelector('[data-product-collection-title]');

      if (link) link.href = selectedContext.url;
      if (title) title.textContent = selectedContext.title;
    });

    const currentHistoryState = history.state && typeof history.state === 'object'
      ? history.state
      : {};

    history.replaceState({
      ...currentHistoryState,
      productBreadcrumbCollection: {
        productHandle,
        type: selectedContext.type,
        handle: selectedContext.handle,
        title: selectedContext.title,
        url: selectedContext.url
      }
    }, '');
  };

  if (!window.productBreadcrumbContextInitialized) {
    document.addEventListener('click', saveCollectionOnProductClick, true);
    window.productBreadcrumbContextInitialized = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateProductBreadcrumb, { once: true });
  } else {
    updateProductBreadcrumb();
  }
})();
